import { useState } from 'react';
import './ReadingsModal.css';
import * as Yup from 'yup';
import Form from '../../../components/form/components/Form/Form';
import FormField from '../../../components/form/components/FormField/FormField';
import Button from '../../../components/form/components/Button/Button';
import ErrorMessage from '../../../components/form/components/ErrorMessage/ErrorMessage';
import { ImCancelCircle } from 'react-icons/im';
import { toast } from 'react-toastify';
import BeatLoader from "react-spinners/BeatLoader";
import moment from 'moment';
import { auth } from '../../../firebase/firebase-config';
import { doc, collection,query, where, getDocs, addDoc,setDoc, getDoc, updateDoc, serverTimestamp, arrayUnion   } from "firebase/firestore"; 

import { useAuthState } from 'react-firebase-hooks/auth';
import { db } from "../../../firebase/firebase-config";

import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

const initialValues= {
    date: null,
    time: null,
    sys: null,
    dia: null,
    pulse: null
}

const override = {
    marginTop: '20px'
  };


function ReadingsModal({ onClose, onContentAdded, activeCaseData } : any) {
    const [error, setError] = useState<any>(null);
    const [loading, setLoading] = useState(false);

    const [user] = useAuthState(auth);
    const [gender, setGender] = useState('');

    const [description, setDescription] = useState("");


    const validationSchema = Yup.object().shape({
        date: Yup.string().required(),
        time: Yup.string().required(),
        sys: Yup.number().required(),
        dia: Yup.number().required(),
        pulse: Yup.number().required()
    })

    // NEW VALS
    const [mealStatus, setMealStatus] = useState("");
    const [medicationStatus, setMedicationStatus] = useState("");
    const [recentActivityVal, setRecentActivityVal] = useState("");


      function toTimeDateLong(timeDateString: any) {
        const format = 'HH:mm:ss DD/MM/YYYY';
        const parsedDate = moment(timeDateString, format);
        
        if (!parsedDate.isValid()) {
          throw new Error('Invalid time string');
        }
        
        return parsedDate.valueOf();
      }

      function calculateXValue(dateLong: any) {
        const allMonths = [31, ((new Date().getFullYear() % 4 === 0) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        let dateTime = new Date(dateLong).toLocaleString();
        const df = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 });
        const fullDate = dateTime.split(',')[0];
        const fullTime = dateTime.split(',')[1].trim();
        const time = fullTime.split(':')[0];
        const date = fullDate.split('/')[1];
        const month = parseInt(fullDate.split('/')[0]) - 1;
        let previous_days = 0;
      
        // console.log('Year', new Date().getFullYear());
      
        if (month > 0) {
          for (let index = 0; index < month; index++) {
            previous_days += allMonths[index];
          }
        }
      
        const value = parseFloat(date) + (parseFloat(time) / 24) + parseFloat(previous_days.toString());
        // console.log('value', df.format(value));
        
        return parseFloat(df.format(value));
      }
    
    const handleSubmitData = async (values: any) => {
            setLoading(true);
            const docRef = doc(db, "LiveData", activeCaseData.id); 
            const docSnap = await getDoc(docRef);

            // console.log('data: ', docSnap.exists())
            
            const dateString = `${Number(values?.time.split(":")[0])}:${Number(values?.time.split(":")[1])}:00 ${Number(values?.date.split("-")[2])}/${Number(values?.date.split("-")[1])}/${Number(values?.date.split("-")[0])}`;
            const timeDateLong = toTimeDateLong(dateString);;

            let reqData = {
                id: docSnap.exists() ? docSnap.data().readings?.length : 0,
                activity_status: Number(recentActivityVal),
                date_day: Number(values?.date.split("-")[2]),
                date_month: Number(values?.date.split("-")[1]),
                date_year: Number(values?.date.split("-")[0]),
                // value: Number(values.sugar_level),
                mhour: Number(values?.time.split(":")[0]),
                mminute: Number(values?.time.split(":")[1]),
                // just_from_eating: mealStatus == 'yes' ? true : false,
                medication_status: medicationStatus == 'yes' ? true : false,
                xvalue: calculateXValue(timeDateLong),
                cid: activeCaseData.CID,
                sys: values?.sys,
                dia: values?.dia,
                pulse: values?.pulse
            }

            // console.log(reqData);
            // return;

            if(docSnap.exists()) {
              await updateDoc(doc(db, "LiveData", activeCaseData.id), {
                readings: arrayUnion(reqData)
              });
            }else {
              await setDoc(doc(db, "LiveData", activeCaseData.id), {
                readings: arrayUnion(reqData)
              });
            }
           
           

            setLoading(false);

            toast.success("Reading created successfully", {
              pauseOnHover: false,
              closeOnClick: true,
            });

            onContentAdded();
            onClose();
            // return;

            // setLoading(true);
            // const q = query(collection(db, "Patients"), where("phoneNumber", "==", `+237${values?.patient_phone}`));
            // const querySnapshot = await getDocs(q);
            
            // if(querySnapshot.size > 0) {
            //     console.log('EXIST: ', querySnapshot.docs[0].id)
            //     createNewCase({ ...values, patient_uid: querySnapshot.docs[0].id });
            // }else {
            //     const newPatientUid = await createNewPatient({
            //         name: values.patient_name,
            //         dob: values.patient_dob,
            //         gender: gender,
            //         phone: `+237${values.patient_phone}`,
            //       });
            //     //   console.log('NEW: ', newPatientUid)
            //       createNewCase({ ...values, patient_uid: newPatientUid });
            // }
    }




    return (
        <div>
            <div  className='modal-container student-modal-assignment' id="reports-modal">
                <div className='modal-head'>
                    <p className="modal-title">Readings Data</p>
                    <ImCancelCircle style={{cursor: 'pointer'}} onClick={onClose} size={22} color="#fff"/>
                </div>
                <div className='modal-content'>
                <div style={{textAlign: 'center', marginBottom: '10px'}}>
                    <BeatLoader
                        color="#3080ED" 
                        loading={loading}
                        cssOverride={override}
                    />
                </div>
                <form action="" className="auth-form">

                {error && <ErrorMessage error={error} visible={true} />}
                <Form 
                    initialValues={initialValues}
                    onSubmit={handleSubmitData}
                    validationSchema={validationSchema}
                >
    
                 <p className="label-text">Date: </p>
                    <FormField
                      name="date"
                      type="date"
                    //   placeholder="Date of Birth"
                    />

                    <p className="label-text">Time: </p>
                    <FormField
                      name="time"
                      type="time"
                    //   placeholder="Time"
                    />

                    {/* <br /> */}

                    <p className="label-text">Systolic Reading: </p>
                    <FormField
                      name="sys"
                      type="number"
                      placeholder="Systolic Reading"
                    />


                  {/* <br /> */}

                  <p className="label-text">Diastolic Reading: </p>
                  <FormField
                    name="dia"
                    type="number"
                    placeholder="Diastolic Reading"
                  />

                  {/* <br /> */}

                  <p className="label-text">Pulse: </p>
                  <FormField
                    name="pulse"
                    type="number"
                    placesholder="Pulse"
                  />

                {/* <p className="label-text">
                      Meal:{" "}
                    </p> */}
                    {/* <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setMealStatus(e.target.value);
                      }}
                      className="select-field-modal"
                    >
                      <option value="" selected={true}>
                        Did you get a meal recently
                      </option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select> */}

                    <p className="label-text">
                      Medications (Optional):{" "}
                    </p>
                    <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setMedicationStatus(e.target.value);
                      }}
                      className="select-field-modal"
                    >
                      <option value="" selected={true}>
                        Did you take any medications
                      </option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>

                    <p className="label-text">
                      Recent Activities (Optional):{" "}
                    </p>
                    <select
                      style={{ borderRadius: 5, padding: 10, height: "50px" }}
                      onChange={(e: any) => {
                        setRecentActivityVal(e.target.value);
                      }}
                      className="select-field-modal"
                    >
                      <option value="" selected={true}>
                        Recent Activities
                      </option>
                      <option value="-1">No</option>
                      <option value="0">Moderate (Walking)</option>
                      <option value="1">Vigorous (Running)</option>
                    </select>


                      {!loading && <Button isOutLined={true} isFullWidth={false} title="SUBMIT DATA"/>}

                        </Form>
                </form>
                </div>
            </div>
            <div className="modal-shadow" onClick={onClose}>
               
            </div>
        </div>
    );
}

export default ReadingsModal;



